// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const NewLaunch = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true, easing: "ease-in-out" });
//   }, []);

//   return (
//     <div id="newLaunch">
//       <div className="container">
//       <section
//       className="py-5 position-relative overflow-hidden"
//       style={{
//         background: "linear-gradient(180deg, #F4ECFF 0%, #F8F2FF 100%)",
//       }}
//     >
//       <div className="container">
//         <div className="text-center mb-5">
//             {/* Subheading */}
//           <h5
//             className="fw-semibold mb-4"
//             style={{ color: "#4b5f71" }}
//             data-aos="fade-up"
//             data-aos-delay="200"
//           >
//             A new experience is on the way
//           </h5>
//           {/* Heading */}
//           <h2
//             className="fw-bold display-5 mb-3"
//             style={{ color: "#3F4868" }}
//             data-aos="fade-up"
//           >
//             <span style={{ color: "#6B83A4" }}>Launching Soon....!</span>
//           </h2>
//         </div>

         

//         {/* Description */}
//         <div className="row justify-content-center">
//           <div className="col-lg-10 col-md-11">
//             <p
//               className="fs-5 lh-lg text-center"
//               data-aos="fade-up"
//               data-aos-delay="400"
//               style={{
//                 color: "#3F4868",
//                 backgroundColor: "#E1D9EC",
//                 borderRadius: "16px",
//                 padding: "20px 30px",
//                 boxShadow: "0 4px 12px rgba(63, 72, 104, 0.1)",
//               }}
//             >
                
//               <em style={{fontSize:"25px"}} >
//                   <span
//                     className="flaticon-house-2 d-block"
//                     style={{ fontSize: "80px",  }}
//                   />
//                 <span className="fw-bold" style={{ fontSize:"44px" }}>“ HOMIN ”</span>  —  your complete construction companion in one app.
//               </em>
//             </p>
//           </div>
//         </div>

       
//       </div>

//       {/* Soft background gradients */}
//       <div
//         className="position-absolute rounded-circle"
//         style={{
//           width: "200px",
//           height: "200px",
//           top: "-60px",
//           left: "-60px",
//           background: "radial-gradient(circle, #E1D3F2 0%, transparent 70%)",
//           opacity: 0.6,
//         }}
//       ></div>
//       <div
//         className="position-absolute rounded-circle"
//         style={{
//           width: "260px",
//           height: "260px",
//           bottom: "-100px",
//           right: "-100px",
//           background: "radial-gradient(circle, #B2BEB5 0%, transparent 70%)",
//           opacity: 0.4,
//         }}
//       ></div>
//     </section>
//     </div>
//     </div>
//   );
// };

// export default NewLaunch;


import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./NewLaunch.css"; // 👈 custom styles

const NewLaunch = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-in-out" });
  }, []);

  return (
    <div id="newLaunch">
      <div className="container">
        <section
          className="py-5 position-relative overflow-hidden"
          style={{
            background: "linear-gradient(180deg, #F4ECFF 0%, #F8F2FF 100%)",
          }}
        >
          <div className="container">
            <div className="text-center mb-5">
              {/* Subheading */}
              <h5
                className="fw-semibold mb-4"
                style={{ color: "#4b5f71" }}
                data-aos="fade-up"
                data-aos-delay="200"
              >
                A new experience is on the way
              </h5>

              {/* Heading */}
              <h2
                className="fw-bold display-5 mb-3"
                style={{ color: "#3F4868" }}
                data-aos="fade-up"
              >
                <span style={{ color: "#6B83A4" }}>Launching Soon....!</span>
              </h2>
            </div>

            {/* Description */}
            <div className="row justify-content-center">
              <div className="col-lg-10 col-md-11">
                <p
                  className="fs-5 lh-lg text-center"
                  data-aos="fade-up"
                  data-aos-delay="400"
                  style={{
                    color: "#3F4868",
                    backgroundColor: "#E1D9EC",
                    borderRadius: "16px",
                    padding: "20px 30px",
                    boxShadow: "0 4px 12px rgba(63, 72, 104, 0.1)",
                  }}
                >
                  <em style={{ fontSize: "25px" }}>
                    <span
                      className="flaticon-house-2 d-block"
                      style={{ fontSize: "80px" }}
                    />
                    <span
                      className="fw-bold spin-once"
                      style={{
                        fontSize: "44px",
                        display: "inline-block",
                        color: "#3F4868",
                      }}
                    >
                      HOMIN
                    </span>{" "}
                    — your complete construction companion in one app.
                  </em>
                </p>
              </div>
            </div>
          </div>

          {/* Soft background gradients */}
          <div
            className="position-absolute rounded-circle"
            style={{
              width: "200px",
              height: "200px",
              top: "-60px",
              left: "-60px",
              background: "radial-gradient(circle, #E1D3F2 0%, transparent 70%)",
              opacity: 0.6,
            }}
          ></div>
          <div
            className="position-absolute rounded-circle"
            style={{
              width: "260px",
              height: "260px",
              bottom: "-100px",
              right: "-100px",
              background: "radial-gradient(circle, #B2BEB5 0%, transparent 70%)",
              opacity: 0.4,
            }}
          ></div>
        </section>
      </div>
    </div>
  );
};

export default NewLaunch;
